import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { agentRoles } from "@/constants/agent";
import SuperAdminCompanySelector from "./SuperAdminCompanySelector";

const SuperAdminCompanyBar: FC = () => {
    const { t } = useTranslation(["company"]);
    const user = useCurrentUser();
    if (user?.agent_role !== agentRoles.super_admin) return null;

    return (
        <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-3 shadow-sm">
            <span className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 shrink-0">
                {t("company:activeCompany")}
            </span>
            <SuperAdminCompanySelector />
        </div>
    );
};

export default SuperAdminCompanyBar;
